import env from "@/utils/env";
// console.log(env.ENV)
export const base = (() => {
  switch (env.ENV) {
    case env.SIMULATION:
    case env.DEBUG:
      // return 'http://localhost/api.chinatbox.cn/pg'
      // return 'http://localhost/apipoptobx/pg'
      return "http://192.168.1.7:8095/api";
    // return "http://127.0.0.1:8093/api";
    // return 'http://agent.test.xnzzchina.com/api'
    case env.DEV:
      return "https://my.zxshotel.com/api"; // 正式服
    case env.PRODUCTION:
      return process.env.VUE_APP_BASE_API;
    default:
      return env.LOC_RES;
  }
})();
export const uploadUrl = base + "/upload/file";
export const uploadPicUrl = base + "/upload/oss_file";
